/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TotalEnergyConsumption } from "./TotalEnergyConsumption";
import {
    TotalEnergyConsumptionFromJSON,
    TotalEnergyConsumptionFromJSONTyped,
    TotalEnergyConsumptionToJSON,
} from "./TotalEnergyConsumption";

/**
 *
 * @export
 * @interface TotalEnergyConsumptionResponse
 */
export interface TotalEnergyConsumptionResponse {
    /**
     *
     * @type {number}
     * @memberof TotalEnergyConsumptionResponse
     */
    dayCount?: number;
    /**
     *
     * @type {number}
     * @memberof TotalEnergyConsumptionResponse
     */
    deviceCount?: number;
    /**
     *
     * @type {number}
     * @memberof TotalEnergyConsumptionResponse
     */
    totalConsumptionWh?: number;
    /**
     * Percentage difference in total energy consumption (based on TotalConsumptionWh) from the previous period, can be null if previous period does not have data.
     * @type {number}
     * @memberof TotalEnergyConsumptionResponse
     */
    totalDiffPercentage?: number;
    /**
     *
     * @type {Array<TotalEnergyConsumption>}
     * @memberof TotalEnergyConsumptionResponse
     */
    items?: Array<TotalEnergyConsumption>;
}

/**
 * Check if a given object implements the TotalEnergyConsumptionResponse interface.
 */
export function instanceOfTotalEnergyConsumptionResponse(
    value: object,
): value is TotalEnergyConsumptionResponse {
    return true;
}

export function TotalEnergyConsumptionResponseFromJSON(
    json: any,
): TotalEnergyConsumptionResponse {
    return TotalEnergyConsumptionResponseFromJSONTyped(json, false);
}

export function TotalEnergyConsumptionResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TotalEnergyConsumptionResponse {
    if (json == null) {
        return json;
    }
    return {
        dayCount: json["dayCount"] == null ? undefined : json["dayCount"],
        deviceCount:
            json["deviceCount"] == null ? undefined : json["deviceCount"],
        totalConsumptionWh:
            json["totalConsumptionWh"] == null
                ? undefined
                : json["totalConsumptionWh"],
        totalDiffPercentage:
            json["totalDiffPercentage"] == null
                ? undefined
                : json["totalDiffPercentage"],
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(
                      TotalEnergyConsumptionFromJSON,
                  ),
    };
}

export function TotalEnergyConsumptionResponseToJSON(
    value?: TotalEnergyConsumptionResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        dayCount: value["dayCount"],
        deviceCount: value["deviceCount"],
        totalConsumptionWh: value["totalConsumptionWh"],
        totalDiffPercentage: value["totalDiffPercentage"],
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(
                      TotalEnergyConsumptionToJSON,
                  ),
    };
}
